// @flow
import React, { memo, useCallback } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { globalTheme } from "@cld/component-theme";
import { isMobile } from "utils/domUtils";
import FolderCard from "@cld/folder-card";
import Tooltip from "@cld/tooltip";
import FolderIcon from "../FolderIcon";
import bindActions, { types as ats } from "../../actions";
import FolderItemSkeleton from "./FolderItemSkeleton";

const { SET_NAVIGATION_CURRENT_FOLDER } = ats;

const Wrapper = styled.div`
    margin-left: ${globalTheme.spacing.xl};

    span {
		line-height: 1.2;
    }
`;

type OwnProps = {|
    title: string,
    kind: string,
    isLoading: boolean,
    id: string,
    path: string[],
    driveId: string
|};

type Props = {
    ...OwnProps,
    actions: { [string]: Function }
};

const FolderItem = memo<Props>(
	({
		title, kind, isLoading, id, path, driveId, actions,
	}: Props) => {
		const goToFolder = useCallback(() => {
			actions[SET_NAVIGATION_CURRENT_FOLDER]({
				id,
				path,
				kind,
				driveId,
			});
		}, [kind, driveId, id, path, actions]);

		const onMobile = isMobile();

		const eventsProps = {
			onClick: onMobile ? goToFolder : undefined,
			onDoubleClick: onMobile ? undefined : goToFolder,
		};

		return (
			<Wrapper>
				<FolderCard size="md" {...eventsProps}>
					{isLoading ? (
						<FolderItemSkeleton />
					) : (
						<>
							<FolderIcon kind={kind} variant="contrastLow" size={"xl"}/>
							<Tooltip title={title} maxWidth="md">
								<Tooltip.OverflowTrigger data-test="folder-item-title">{title}</Tooltip.OverflowTrigger>
							</Tooltip>
						</>
					)}
				</FolderCard>
			</Wrapper>
		);
	},
);

export default connect<Props, OwnProps, _, _, _, _>(
	null,
	(dispatch: Function) => ({
		actions: bindActions(dispatch),
	}),
)(FolderItem);
